import { useEffect } from "react";
import { Loading } from "../components/Loading";
import { ConnectionsListSection } from "../sections/ConnectionsListSection";
import _ from "lodash";
import { useGetConnectedPlatforms } from "../logic/hooks/useGetConnectedPlatforms";
export const ControlledConnectionsList = ({
  title,
  linkTokenEndpoint,
  linkHeaders,
  setIntegrationId,
  setClientId,
  setSecretId,
  setConnectionGuide,
  selectedConnection,
  setRequestId,
  setUseDefaultOauthCreds,
  setIsWhiteLabel,
}: {
  title?: string;
  linkTokenEndpoint: string;
  linkHeaders?: Record<string, unknown>;
  setIntegrationId: (id: number | undefined) => void;
  setClientId: (id: string | undefined) => void;
  setSecretId?: (id: string | undefined) => void;
  setConnectionGuide?: (url: string | undefined) => void;
  selectedConnection?: number | string;
  setSessionId: (id: string) => void;
  sessionId: string;
  setRequestId: (id: number | undefined) => void;
  setUseDefaultOauthCreds: (value: boolean) => void;
  setIsWhiteLabel: (value: boolean | null) => void;
}) => {
  const { data: connectedPlatforms, isLoading, requestId, isWhiteLabel } = useGetConnectedPlatforms({
    linkTokenEndpoint,
    linkHeaders: linkHeaders as Record<string, unknown>,
  });     

  // Update isWhiteLabel in parent when data is loaded
  // If API returns undefined, default to false (show branding)
  useEffect(() => {
    if (!isLoading) {
      setIsWhiteLabel(isWhiteLabel ?? false);
    }
  }, [isLoading, isWhiteLabel, setIsWhiteLabel]);


  if (selectedConnection && connectedPlatforms) {
    const platform = connectedPlatforms.find(
      (platform) =>
        platform?.title === selectedConnection ||
        platform?.connectionDefId === selectedConnection ||
        platform?.connectionDefinitionId === selectedConnection
    );



    if (platform?.connectionDefId) {
      setIntegrationId?.(platform.connectionDefId);
    }

    if (platform?.connectionDefinitionId) {
      setIntegrationId?.(platform.connectionDefinitionId);
    }

    if (platform?.clientIdDisplay) {
      setClientId(platform.clientIdDisplay);
    }

    if (platform?.secret?.clientId) {
      setClientId(platform.secret.clientId);
    }

    // Set useDefaultOauthCreds flag for OAuth integrations using default credentials
    if (platform?.useDefaultOauthCreds) {
      setUseDefaultOauthCreds(true);
    }

    if (platform?.guide) {
      setConnectionGuide?.(platform.guide);
    }

    if (platform?.secretId) {
      setSecretId?.(platform.secretId);
    }

    if (platform?.secretsServiceId) {
      setSecretId?.(platform.secretsServiceId);
    }

    if (requestId) {
      setRequestId(requestId);
    }
  }

  const handleClose = async () => {
    window?.parent?.postMessage(
      {
        messageType: "EXIT_EVENT_LINK",
      },
      "*"
    );
  };

  const handleClick = ({
    id,
    clientId,
    secretId,
    connectionGuide,
    useDefaultOauthCreds,
  }: {
    id: number;
    clientId?: string;
    secretId?: string;
    connectionGuide?: string;
    useDefaultOauthCreds?: boolean;
  }) => {

    setIntegrationId(id);
    setClientId?.(clientId);
    setSecretId?.(secretId);
    setConnectionGuide?.(connectionGuide);
    setRequestId(requestId);
    setUseDefaultOauthCreds(useDefaultOauthCreds ?? false);
  };

  const activePlatforms = _.orderBy(
    connectedPlatforms?.filter((platform) => platform?.active),
    ["title"],
    ["asc"]
  );

  return (
    <>
      {isLoading && (
        <Loading message="Loading integrations" onClose={handleClose} />
      )}
      {!isLoading && (
        <ConnectionsListSection
          connectedPlatforms={activePlatforms}
          title={title}
          onClose={handleClose}
          onClick={handleClick}
        />
      )}
    </>
  );
};
